import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.fullBleedingBox,
    background: theme.mixins.Black(30),
    '& ul': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
    '& .l2List': {
      marginTop: theme.spacing(2),
      '&:first-of-type': {
        [theme.breakpoints.up('lg')]: {
          marginTop: theme.spacing(3),
        },
      },
    },
    '& .l3Item': {
      color: theme.palette.text.tertiary,
      marginTop: theme.spacing(1),
    },
  },
  l1List: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(8),
      ...theme.mixins.paddingRight(theme.spacing(2)),
    },
  },
  link: {
    display: 'inline-block',
    margin: 0,
    '&:hover': {
      color: theme.mixins.AbuDhabiOrange(),
    },
  },
}));

export default useStyles;